<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
                ref="terminalAudit"
                :visible="FeedbackShow"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">投诉人信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">投诉人：</span>
                        <span>{{dialogData.data.merchant_detail}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">被投诉人：</span>
                        <span>{{dialogData.data.user_detail}}</span>
                    </el-col>
                    <el-col :span="24" v-if="litigation_id">
                        <span class="labels">第{{dialogData.data.num}}投诉</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">回馈：</span>
                        <el-card class="box-card" shadow="hover">
                            <el-row :gutter="20">
                                <span v-html="content"></span>
                            </el-row>
                        </el-card>
                    </el-col>
                </el-row>
                <el-form
                        label-position="top"
                        label-width="80px">
                    <tinymce v-model="auditForm.content" ref="editor" @getVal="getVal" />
                </el-form>
                <div style="margin-top:40px;text-align: center">
                    <el-button
                            @click="submit(2)"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >驳 回</el-button>
                    <el-button
                            @click="submit(1)"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >提 交</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import tinymce from '../../components/Editor/Editor2'
export default {
    name: "merchant-examine",
    props: {
        FeedbackShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    data() {
        return {
            auditForm: {
                litigation_id:this.dialogData.data.litigation_id, //投诉id
                num:this.dialogData.data.num,
                content:'',
            },
            loading: false,
            checked: true,
            activeName: '',
            litigation_id:this.dialogData.data.litigation_id,
            content:''
        }
    },
    mounted() {
        this.list()
    },
    methods: {
        // 获取处罚信息
        list() {
            this.$api.post('merchant/examineShow', this.auditForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.content = data[0].content;
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        getVal(val) {
            this.auditForm.content = val;
        },
        // 提交处罚数据
        handleClose(ref) {
            this.$emit('infoClose', ref);
        },
        submit(type){ //驳回/提交
            this.$api.post('merchant/updateExamine', {data:this.auditForm,type:type}, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        }
    },
    components: {
        tinymce
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
</style>
